import { render, staticRenderFns } from "./CancelMail.vue?vue&type=template&id=669503fa&scoped=true&"
import script from "./CancelMail.vue?vue&type=script&lang=js&"
export * from "./CancelMail.vue?vue&type=script&lang=js&"
import style0 from "./CancelMail.vue?vue&type=style&index=0&id=669503fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669503fa",
  null
  
)

export default component.exports